<template>

<app-content :loading="is.loading">

	<app-content-head title="Settings" :readonly="$authorised('con/checkout/access', 'read')">

		<app-content-head-actions-item :disabled="!isDirty" icon="undo" text="Undo" v-on:click="onUndoClick" />
		<app-content-head-actions-item :loading="is.saving" :disabled="!isDirty || !isValid" icon="save" text="Save" v-on:click="onSaveClick" />

	</app-content-head>

	<app-content-body>

		<app-content-box :tabs="tabs" :readonly="$authorised('con/checkout/access', 'read')">

			<template v-slot:loans>

				<app-input-text :toggle="model.checkout.limit.games.enabled" v-on:toggle="model.checkout.limit.games.enabled = !model.checkout.limit.games.enabled" label="Active Loan Limit" v-model="model.checkout.limit.games.amount" :validation="$v.model.checkout.limit.games.amount" notes="The maximum number of games a single badge holder can have checked out at any one time." />
				
				<app-input-text :toggle="model.checkout.limit.hours.enabled" v-on:toggle="model.checkout.limit.hours.enabled = !model.checkout.limit.hours.enabled" label="Due Threshold" v-model="model.checkout.limit.hours.amount" :validation="$v.model.checkout.limit.hours.amount" notes="The number of hours at which a unreturned game becomes overdue." />
				
				<app-input-text :toggle="model.checkout.verification.enabled" v-on:toggle="model.checkout.verification.enabled = !model.checkout.verification.enabled" label="Verification" placeholder="Enter name of field..." v-model="model.checkout.verification.title" :validation="$v.model.checkout.verification.title" notes="Track a value upon checkout that can be manually verified against on checkin (e.g. physical weight)." />

			</template>

			<template v-slot:wins>

				<app-input-text :autogrow="true" label="Description" notes="Description shown on the Play to Win page to attendees." v-model="model.checkout.playtowin.description" :validation="$v.model.checkout.playtowin.description" placeholder="Enter message" />

				<app-input-checklist label="Repeat Wins" v-model="model.checkout.playtowin.repeats" :validation="$v.model.checkout.playtowin.repeats" :options="$constants.checkout.win.repeatsName" :descriptions="$constants.checkout.win.repeatsDescription" :fullWidth="true" :singular="true" :columns="1" />
				
				<app-input-text :toggle="model.checkout.playtowin.outlier.enabled" v-on:toggle="model.checkout.playtowin.outlier.enabled = !model.checkout.playtowin.outlier.enabled" label="Min. Minutes" v-model="model.checkout.playtowin.outlier.amount" :validation="$v.model.checkout.playtowin.outlier.amount" notes="Required minimum duration a game must be checked out for the players to be eligible to win." />

			</template>

			<template v-slot:reports>

			</template>

		</app-content-box>

	</app-content-body>

</app-content>

</template>

<script>

import mixForm from '@/mixin/form'

export default {

	mixins: [mixForm],

	data: function() {

		return {
			settings: true,
			readonly: this.$authorised('con/checkout/access', 'read'),
			tabs: [
				{ name: 'loans', text: 'Loans' },
				{ name: 'wins', text: 'Play to Win' },
				/*{ name: 'reports', text: 'Reports' }*/
			],
			model: {
				checkout: {
					limit: {
						games: {
							enabled: false,
							amount: 0
						},
						hours: {
							enabled: false,
							amount: 0
						}
					},
					verification: {
						enabled: false,
						title: ''
					},
					logging: {
						enabled: false
					},
					playtowin: {
						description: '',
						repeats: 2,
						outlier: {
							enabled: false,
							amount: 0
						}
					}
				}
			}
		}

	},

	validations: {
		model: {
			checkout: {
				limit: {
					games: {},
					hours: {}
				},
				verification: {
					title: {}
				},
				playtowin: {
					outlier: {}
				},
				logging: {}
			}
		}
	}

}

</script>

<style scoped>

</style>